// Team members — names + roles. Replace the headshot images by overwriting
// the matching files in /app/frontend/public/team/{id}.jpg
export const TEAM = [
  {
    id: "mohamad-itani",
    img: "/team/mohamad-itani.jpg",
    name: "Mohamad Itani",
    role_en: "CEO",
    role_ar: "الرئيس التنفيذي",
    role_fr: "PDG",
  },
  {
    id: "ibrahim",
    img: "/team/ibrahim.jpg",
    name: "Ibrahim Kobeisy",
    role_en: "Co-Founder & CEO",
    role_ar: "شريك مؤسس والرئيس التنفيذي",
    role_fr: "Co-fondateur & PDG",
  },
  {
    id: "mohyelden",
    img: "/team/mohyelden.jpg",
    name: "Mohyelden Berjawi",
    role_en: "CEO",
    role_ar: "الرئيس التنفيذي",
    role_fr: "PDG",
  },
  {
    id: "izzat",
    img: "/team/izzat.jpg",
    name: "Izzat Mahayri",
    role_en: "Finance & Accounting Manager",
    role_ar: "مدير المالية والمحاسبة",
    role_fr: "Directeur finance & comptabilité",
  },
  {
    id: "jill",
    img: "/team/jill.jpg",
    name: "Jill",
    role_en: "Operations Manager",
    role_ar: "مديرة العمليات",
    role_fr: "Directrice des opérations",
  },
  {
    id: "anas",
    img: "/team/anas.jpg",
    name: "Anas Trabolsi",
    role_en: "Warehouse Coordinator",
    role_ar: "منسق المستودع",
    role_fr: "Coordinateur d'entrepôt",
  },
  {
    id: "houssam",
    img: "/team/houssam.jpg",
    name: "Houssam Berjawi",
    role_en: "Sales & Purchasing Coordinator",
    role_ar: "منسق المبيعات والمشتريات",
    role_fr: "Coordinateur ventes & achats",
  },
  {
    id: "nourhan",
    img: "/team/nourhan.jpg",
    name: "Nourhan Makouk",
    role_en: "Customer Service",
    role_ar: "خدمة العملاء",
    role_fr: "Service client",
  },
  {
    id: "jamal",
    img: "/team/jamal.jpg",
    name: "Jamal Hawwa",
    role_en: "Sales & Purchasing Coordinator",
    role_ar: "منسق المبيعات والمشتريات",
    role_fr: "Coordinateur ventes & achats",
  },
];
